// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".background-pattern{position:absolute;width:100%;height:100%;top:0;left:0;background-size:100% auto;background-position:top;background-repeat:repeat-y;opacity:.05}.background-pattern~.project-area__container,.background-pattern~section{position:relative;z-index:1}", ""]);
// Exports
module.exports = exports;
